import { LocalStorage } from '@/config'
import { appStatusStore } from '@/stores'
import { useCallback, useEffect, useState } from '@codeleap/hooks'
import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'

const loadedAtom = atom(true)

export function useSessionMode(readMode = false) {
  const loaded = useStore(loadedAtom)

  const initMode = (isDev: boolean, type: string) => {
    appStatusStore.toggleDevMode(isDev)
    loadedAtom.set(true)
    logger.log('Mode loaded', { isDev, type })
  }

  const resolveSessionMode = useCallback(() => {
    const mode = LocalStorage.getItem('SESSION_IS_DEV', false)

    const isDevSession = typeof mode === 'string' ? JSON.parse(mode) : false

    return isDevSession
  }, [])

  async function loadMode() {
    try {
      const sessionMode = resolveSessionMode()

      return initMode(sessionMode, 'session')
    } catch (err) {
      logger.error({ err })
    }
  }

  return {
    loaded,
  }
}
